import { Site } from '@reenstudio/app/core/models/site/site';
import { SiteType } from '@reenstudio/app/core/enum/site-type';
import { invoiceTypeNames } from './invoice-type';

export const SITE_LIST_MOCK: Site[] = [
  // {
  //   id: 1,
  //   description: 'Prosumer 1', // Intrapresa
  //   profile_type_id: 'Residenziale',
  //   address: 'VIA DEI MILLE, 2',
  //   city: 'RAGUSA',
  //   province: 'RG',
  //   email: 'matteorossi@email.it',
  //   activation: '2023-10-30',
  //   type: SiteType.PROSUMER,
  //   invoiceType: invoiceTypeNames[0].description,
  //   consumerProfile: 147,
  //   active: true,
  // },
  // {
  //   id: 2,
  //   name: 'Consumer 1', // Spampinato
  //   value: 'c2g-57CFA5290',
  //   profile_type_id: 'Residenziale',
  //   address: 'VIA PARIOLI, 205',
  //   city: 'RAGUSA',
  //   province: 'RG',
  //   email: 'alessiafrongia@email.it',
  //   activation: '2023-08-30',
  //   type: SiteType.CONSUMER,
  //   invoiceType: invoiceTypeNames[1].description,
  //   consumerProfile: 10,
  //   active: true,
  // },
  // {
  //   id: 3,
  //   name: 'Consumer 2', // Barone
  //   value: 'c2g-57CFAB728',
  //   profile_type_id: 'Residenziale',
  //   address: 'VIA GARIBALDI, 2',
  //   city: 'RAGUSA',
  //   province: 'RG',
  //   email: 'vittoriomarrone@email.it',
  //   activation: '2023-10-13',
  //   type: SiteType.CONSUMER,
  //   invoiceType: invoiceTypeNames[0].description,
  //   consumerProfile: 61,
  //   active: true,
  // },
  // {
  //   id: 4,
  //   name: 'Prosumer 2', // Puccia
  //   value: 'c3p-7B2F97BDC',
  //   profile_type_id: 'Industria',
  //   address: 'CORSO UMBERTO, 111',
  //   city: 'RAGUSA',
  //   province: 'RG',
  //   email: 'alessandrovolta@email.it',
  //   activation: '2023-08-01',
  //   type: SiteType.PROSUMER,
  //   invoiceType: invoiceTypeNames[0].description,
  //   consumerProfile: 4,
  //   active: true,
  // },
];
